import QueryString from "query-string";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useMeCore } from "../../../../cores/me";
import { useRouterCore } from "../../../../cores/router";
import { useYoutubeCore } from "../../../../cores/youtube";

const OAUTH_HANDLED_PREFIX = "wembii-youtube-oauth:";
const oauthCodesInFlight = new Set<string>();

export default function YoutubePopUp() {
  const { search } = useLocation();
  const { bind, get } = useYoutubeCore();
  const { companyId, getMeSocialSettings } = useMeCore();
  const { goToBinding } = useRouterCore();
  const handledRef = useRef(false);

  useEffect(() => {
    const { code } = QueryString.parse(search);
    const authCode = Array.isArray(code) ? code[0] : code;

    if (!authCode || !companyId) return;

    const storageKey = `${OAUTH_HANDLED_PREFIX}${authCode}`;
    if (
      handledRef.current ||
      oauthCodesInFlight.has(authCode) ||
      sessionStorage.getItem(storageKey)
    ) {
      return;
    }

    handledRef.current = true;
    oauthCodesInFlight.add(authCode);
    sessionStorage.setItem(storageKey, "1");

    void (async () => {
      try {
        await bind(String(companyId), authCode, () => {
          getMeSocialSettings(String(companyId));
        });
        await get(String(companyId));
      } catch (error) {
        console.error("[YoutubePopUp] bind failed", error);
      } finally {
        oauthCodesInFlight.delete(authCode);
        goToBinding();
      }
    })();
  }, [search, companyId, bind, get, goToBinding, getMeSocialSettings]);

  return <div />;
}
